import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import {NewsComment} from "../model/news-comment";
import {NewComment} from "../model/new-comment";
import {NewsSharedService} from "../../../services/news-shared.service";
import {Utils} from "../../../../../common/services/Utils";
import {UserInfo} from "../../../../user/components/user-information/users-info";


@Component({
  selector: 'app-comments-block',
  templateUrl: './comments-block.component.html',
  styleUrls: ['./comments-block.component.scss']
})
export class CommentsBlockComponent implements OnInit, AfterViewInit {
  @Input() public comments: NewsComment[];
  @Input() public subcomments: NewsComment[];
  @Input() public userDto: UserInfo;
  @Input() public newsId: number;
  @Input() public newsAuthorId: number;
  @Input() public commentId: number;
  @Input() public sendComment: NewComment;
  @Input() public moderators: any[];
  @Output() valueChange = new EventEmitter();

  canDeleteComment: boolean = false;

  constructor(private _utils: Utils,
              private newsSharedService: NewsSharedService) {
  }

  ngOnInit() {
    this.fillCommentFrom();
  }

  ngAfterViewInit(): void {
  }

  setReplyTo(comment: NewsComment) {
    if (comment && comment.id) {
      this.sendComment.replyTo = comment.id;
      this.sendComment.text = ((comment.authorName) ? comment.authorName : '') + ', ';
      this.goToCommentForm();
    } else {
      this.sendComment.replyTo = null;
      this.sendComment.text = null;
    }
  }

  sendCommentBtn() {
    if (this.sendComment.userName && this.sendComment.userEmail && this.sendComment.text) {
      if (!this.sendComment.userEmail.match('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')){
        this._utils.notifyError('email_input_error', null);
        return null;
      }
      let newsComment: NewsComment = new NewsComment();
      if (this.userDto) {
        newsComment.authorId = this.userDto.id;
      }
      newsComment.newsId = this.newsId;
      newsComment.parentCommentId = this.sendComment.replyTo;
      newsComment.authorName = this.sendComment.userName;
      newsComment.authorEmail = this.sendComment.userEmail;
      newsComment.commentText = this.sendComment.text;
      if (this.sendComment.id && this.sendComment.editIndex > -1) {
        newsComment.id = this.sendComment.id;
        console.log('newsComment', newsComment, this.sendComment.editIndex);
        this.newsSharedService.editComment(newsComment).subscribe(data=>{
          if (data) {
            console.log('editComment', data);
            this._utils.notifySuccess('news_add_edit.save_success', null);
            this.comments[this.sendComment.editIndex] = data;
            this.fillCommentFrom();
          } else {
            this._utils.notifyError('news_add_edit.error_save', null);
          }
        }, error => {
          this._utils.notifyError('news_add_edit.error_save', null);
          console.log('editComment error!', error);
        });
      } else {
        this.newsSharedService.addNewComment(newsComment).subscribe(data=>{
          console.log('addNewComment', data);
          this._utils.notifySuccess('news_add_edit.save_success', null);
          this.fillCommentFrom();
          this.comments.push(data);
        }, error => {
          this._utils.notifyError('news_add_edit.error_save', null);
          console.log('addNewComment error!', error);
        });
      }
    } else {
      this._utils.notifyError('news_add_edit.fill_required_fields', null);
    }
  }

  deleteComment(comment: NewsComment) {
    if (comment) {
      this.newsSharedService.deleteComment(comment).subscribe(data=>{
        console.log('deleteComment', data);
        if (data) {
          if (data['status'] === 'DELETED') {
            this._utils.notifySuccess('news_add_edit.save_success', null);
            if (this.comments) {
              this.comments.splice(this.comments.indexOf(comment), 1);
            } else if (this.subcomments) {
              this.subcomments.splice(this.subcomments.indexOf(comment), 1);
            }
          } else if (data['status'] === 'ERROR') {
            console.log('deleteComment error!', data['message']);
            this._utils.notifyError('news_add_edit.error_save', null);
          }
        }
      }, error => {
        console.log('deleteComment error!', error);
      });
    }
  }

  editComment(comment: NewsComment) {
    console.log('editComment', comment);
    if (comment) {
      this.sendComment.text = comment.commentText;
      this.sendComment.id = comment.id;
      this.sendComment.editIndex = (this.comments ? this.comments.indexOf(comment) : this.subcomments.indexOf(comment));
      console.log('editIndex', this.sendComment.editIndex);
      this.goToCommentForm();
    }
  }


  fillCommentFrom() {
    if (this.userDto) {
      this.sendComment.userName = this.userDto.firstName + ' ' + this.userDto.lastName;
      this.sendComment.userEmail = this.userDto.email;
    }
    this.sendComment.id = null;
    this.sendComment.text = null;
    this.sendComment.editIndex = null;
    this.sendComment.replyTo = null;
  }

  goToCommentForm() {
    const element = document.getElementById('comment-send-block');
    element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  canDeleteCommentFunc(moderators: any[]) {
    // console.log('canDeleteCommentFunc moderators', moderators)
    if (this.userDto && moderators) {
      return moderators.indexOf(this.userDto.id) > -1;
    }
    return false;
  }

  canEditCommentFunc(comment: any) {
    // if (this.userDto && comment) {
    //   return this.userDto.id === comment['authorId'];
    // }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/news-layout/comments-block/comments-block.component.ts